export default "__VITE_ASSET__CEgI$8jT__"